/** Actions types ***/

export const SET_FILE_UPLOADING = '[FILE] SET UPLOADING';

//--------------------------
/** Actions **/

/**
 *
 * @param {Boolean} uploading
 */
export const setFileUploading = uploading => {
  return {
    type: SET_FILE_UPLOADING,
    uploading,
  };
};
